import timePickerDarkRule from '../../../common/algorithms/time-picker-dark-rule';

const dark = (params) => timePickerDarkRule(params, { step: 1, darkShade: '200' });

export default dark;
